<template>
  <!--
div
  .container
    .row.mb-2
      .col-9
        input.form-text(placeholder="郵便番号を入力してください")
      .col-3
        .button.is-orange.is-small 調べる
  -->
  <div>
    <form class="" @submit.prevent="checkSupportArea">
      <div class="row mb-2">
        <div class="col-9">
          <input
            type="text"
            name="postal-code"
            maxlength="8"
            class="form-text"
            placeholder="郵便番号を入力してください"
            v-model="zip_code"
            autocomplete="postal-code"
            @input="change"
            @keyup="change"
            ref="input_postal_code"
            pattern="\d*"
          >
        </div>
        <div class="col-3">
          <button
            class="button is-orange is-small"
            :class="buttonClass"
            :disabled="buttonDisabled"
            @click="checkSupportArea"
            >
              <span v-show="is_fetch" class="loader"></span>
              <span v-show="!is_fetch">調べる</span>
          </button>
        </div>
      </div>
    </form>
    <div v-if="status === 'match'" class="mb-3">
      <div class="bg is-blue">
        <p class="text-5 text-bold tac">〒{{formated_zip_code}}</p>
        <p class="text-3 tac">({{addr.region}} {{addr.locality}})<br>は、<span class="text-5 text-bold text-orange">往診対応エリア</span>です。</p>
      </div>
    </div>
    <div v-else-if="status === 'noMatch'" class="mb-3">
      <div class="bg is-gray tac">
        <p class="text-5 text-bold">〒{{formated_zip_code}}</p>
        <p class="text-4">申し訳ございません、<br>
        現在<span class="text-5 text-bold text-orange">往診エリア対象外</span>です。 </p>
        <p class="text-4">今後、エリア拡大に努めてまいります。</p>
      </div>
    </div>
    <div v-else-if="status === 'error'" class="mb-3">
      <div class="bg is-gray tac">
        <p class="text-4 text-bold">エラーで正常に取得できませんでした。<br>お手数ですがお時間を空けて<br>再度お試しください。</p>
      </div>
    </div>


  </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import {getEndPoint} from '../config';

export default Vue.extend({
  name: 'YubinCheck',
  data() {
    return {
      status: '',
      zip_code: '',
      addr: {
        extended: '',
        locality: '',
        region: '',
        region_id: 0,
        street: '',
      },
      page: 'area',
      is_production: false,
      is_changed: false,
      is_fetch: false,
      endpoint: '',
    }
  },
  created() {
    this.is_production = process.env.NODE_ENV  === 'production'
    this.endpoint = getEndPoint(process.env.NODE_ENV);
  },
  mounted(){
    this.page = 'night-area';
  },
  computed: {
    canSearch(){
      if (this.is_fetch || !this.addr.region || !this.addr.locality || !this.addr.street) {
        return false;
      }
      return true;
    },
    buttonClass(){
      if (!this.canSearch) {
        return 'is-disabled'
      }
      return ''
    },
    buttonDisabled(){
      return !this.canSearch
    },
    sanitize_zip_code(){
      const zip =  this.zip_code
        .replace(/(\-|ー)/g, '')
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s=> {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }
      )
      if (zip.length != 7) return ''
      return zip
    },
    formated_zip_code(){
      if(!this.sanitize_zip_code) return ''
      if(this.sanitize_zip_code.length < 7) return ''
      const str = this.sanitize_zip_code.replace(/[^0-9]/g, '')
      return str.substr(0, 3) + "-" + str.substr(3, 4)
    },
  },
  methods: {
    conversionEventTracking(category, action, str){
      if(!this.is_production) return;
      window.FD.conversionEventTracking(category, action, str);
    },
    change(){
      this.status = ''
      this.addr = {}
      if (this.sanitize_zip_code ==! '') return
      new YubinBango.Core(this.sanitize_zip_code, (addr) => {
        // console.log(addr)
        this.addr = addr;
      })

      if(this.is_changed) return
      this.conversionEventTracking(this.page, 'input', 'zip_code')
      this.is_changed = true;
    },
    async checkSupportArea(){
      if (this.buttonDisabled) return
      if (!this.addr.region) {console.error("region not found"); return}
      if (!this.addr.locality) {console.error("locality not found"); return}
      if (!this.addr.street) {console.error("street not found"); return}
      this.conversionEventTracking(this.page, 'click', 'search')
      this.is_fetch = true;
      const response = await axios({
        method: "POST",
        url: this.endpoint.area,
        data: {
          address: {
            prefecture_name: this.addr.region,
            city_name: this.addr.locality,
            address1: this.addr.street,
          }
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer dummyToken"
        }
        })
        .catch((e) => {
          console.error('error', e);
          this.status = 'error';
        });
      this.is_fetch = false;
      this.$refs.input_postal_code.blur();
      // console.log("response", response);
      if (!response || !response.data) {
        console.error('response.data is not found');
        this.status = 'error';
      }
      if (response.data.available === true) {
        this.status = 'match';
        return
      }
      this.status = 'noMatch';
      return
    },
    toOushin(event){
      this.conversionEventTracking(this.page, 'click', 'toOushin')
      if (!window.pagescroll) { console.error('not found pagescroll'); return; }
      const href = event.target.getAttribute('href')
      event.preventDefault();
      // console.log("href", href);
      window.pagescroll.scrollTo(href, -160)
    }
  },
});
</script>
